import { render, staticRenderFns } from "./VehicleDash.vue?vue&type=template&id=b83e2012&"
import script from "./VehicleDash.vue?vue&type=script&lang=js&"
export * from "./VehicleDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports